import styled from 'styled-components';
import { StyledGenericModalFooter } from '@/components/uielements/genericModal/styles';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { LAYOUT } from '@/constants/styles';

export const StyledOrderTimeContainer = styled.div<{ isVisible: boolean }>(({ isVisible }) => ({
  display: isVisible ? 'initial' : 'none',
}));

export const StyledModalContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '34px',
  position: 'relative',
  padding: `${LAYOUT.GUTTER}px`,
  paddingTop: '0px',
});

export const StyledModalFooter = styled(StyledGenericModalFooter)(() => ({
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
  padding: '32px 0px 0px 0px',
}));

export const StyledConfirmButton = styled(StyledPrimaryButton)(() => ({
  fontSize: '16px',
  width: '100%',
}));

export const StyledCancelButton = styled(StyledConfirmButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.global.primary_active_color,

  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.global.primary_active_color,
    textDecoration: 'underline',
    color: theme.global.primary_active_color,
  },
}));
